import { ArticleTypeCode } from '@/types/article'
import { Platform } from '@/types/platform'
import {
  UserPermission,
  UserPermissionField,
  UserPermissionPage,
  UserPermissionWidgetField,
} from '@/types/user'
import { ImageWidgetSourceType } from '@/types/widget/imageset'
import { ENABLED_GOODS_WIDGET } from './widget'

export const articleWidgets = (): {
  title: string
  slug: string
  icon: string
  tag?: string
  text?: string
  count?: number
  svg: boolean
  commandToExec?: string
  quantity?: number
  accessPlatforms?: Platform[]
  exludeArticleTypes?: ArticleTypeCode[]
  includeArticleTypes?: ArticleTypeCode[]
  hiddenMobile?: boolean
  permissions?: {
    page: UserPermissionPage
    list: UserPermission[]
    fields?: {
      field: UserPermissionField
      permissions: UserPermission[]
    }[]
  }[]
}[] => {
  const widgets = [
    {
      title: 'Абзац',
      slug: 'text-block',
      icon: 'mdi-format-size',
      tag: 'p',
      text: '',
      svg: false,
    },
    {
      title: 'Ненумерованный список',
      slug: 'text-block',
      icon: 'format_list_bulleted',
      commandToExec: 'bulletedlist',
      tag: 'ul',
      text: '<ul><li></li></ul>',
      svg: false,
    },
    {
      title: 'Нумерованный список',
      slug: 'text-block',
      icon: 'format_list_numbered',
      commandToExec: 'numberedlist',
      tag: 'ol',
      text: '<ol><li></li></ol>',
      svg: false,
    },
    {
      title: 'HTML-код',
      slug: 'html',
      icon: 'mdi-code-tags',
      svg: false,
      permissions: [
        {
          page: UserPermissionPage.WIDGET,
          list: [UserPermission.EDIT],
          fields: [
            {
              field: UserPermissionWidgetField.HTML,
              permissions: [UserPermission.EDIT],
            },
          ],
        },
      ],
    },
    {
      title: 'Фото',
      slug: 'imageset',
      icon: 'mdi-image-outline',
      svg: false,
    },
    {
      title: '2 фото',
      slug: 'photos',
      icon: 'mdi-image-multiple-outline',
      svg: false,
      count: 2,
      exludeArticleTypes: [ArticleTypeCode.PHOTO],
    },
    {
      title: 'Цитата',
      slug: 'citation',
      icon: 'mdi-format-quote-close-outline',
      svg: false,
      accessPlatforms: [
        Platform.bazaar,
        Platform.cosmo,
        Platform.esquire,
        Platform.goodhouse,
        Platform.grazia,
        Platform.mhealth,
        Platform.popmech,
        Platform.robb,
        Platform.girlspower,
        Platform.arcan,
      ],
    },
    {
      title: 'Цитата',
      slug: 'quoteModel',
      icon: 'mdi-format-quote-close-outline',
      svg: false,
      accessPlatforms: [Platform.vslova],
    },
    {
      title: 'Факт',
      slug: 'fact',
      icon: 'mdi-playlist-check',
      svg: false,
    },
    {
      title: 'Эксперт',
      slug: 'newExpert',
      icon: require('@/assets/icons/expert.svg'),
      svg: true,
    },
    {
      title: 'Опрос',
      slug: 'poll',
      icon: 'mdi-chart-box-outline',
      svg: false,
    },
    {
      title: 'Тест',
      slug: 'test',
      icon: 'mdi-checkbox-outline',
      svg: false,
    },
    {
      title: 'Галерея',
      slug: 'gallery',
      icon: 'mdi-view-carousel-outline',
      svg: false,
    },
    {
      title: 'Видео',
      slug: 'video',
      icon: require('@/assets/icons/play.svg'),
      svg: true,
    },
    // {
    //   title: 'Видео код',
    //   slug: 'video',
    //   icon: 'mdi-television-play',
    //   svg: false,

    //   raw: {
    //     added_via: 'code',
    //   },
    // },
    // {
    //   title: 'Код',
    //   slug: 'embed-element',
    //   icon: 'mdi-code-tags',
    //   svg: false,
    // },
    {
      title: 'TikTok',
      slug: 'tiktok',
      icon: require('@/assets/icons/tiktok.svg'),
      svg: true,
    },
    {
      title: 'Сoub',
      slug: 'coub',
      icon: require('@/assets/icons/coub.svg'),
      svg: true,
    },
    {
      title: 'Vkontakte',
      slug: 'vk',
      icon: require('@/assets/icons/vk-c.svg'),
      svg: true,
    },
    {
      title: 'Telegram',
      slug: 'telegram',
      icon: require('@/assets/icons/telegram.svg'),
      svg: true,
    },
    {
      title: 'Одноклассники',
      slug: 'ok',
      icon: require('@/assets/icons/ok-c.svg'),
      svg: true,
    },
    {
      title: 'Giphy',
      slug: 'giphy',
      icon: require('@/assets/icons/gif.svg'),
      svg: true,
    },
    {
      title: 'Подборка рецептов',
      slug: 'recipe_compilation',
      icon: require('@/assets/icons/recipe_compilation.svg'),
      svg: true,
      accessPlatforms: [Platform.goodhouse, Platform.cosmo, Platform.mhealth],
    },
    {
      title: 'Это интересно',
      slug: 'interest',
      icon: 'mdi-lightbulb-on-outline',
      svg: false,
      accessPlatforms: [
        Platform.goodhouse,
        Platform.bazaar,
        Platform.cosmo,
        Platform.esquire,
        Platform.grazia,
        Platform.mhealth,
        Platform.popmech,
        Platform.robb,
        Platform.girlspower,
      ],
    },
    {
      title: 'Аудио',
      slug: 'audio',
      icon: require('@/assets/icons/audio.svg'),
      svg: true,
    },
    {
      title: 'Кнопка автоперехода',
      slug: 'redirectButton',
      icon: '$moveDown',
      svg: false,
      permissions: [
        {
          page: UserPermissionPage.WIDGET,
          list: [UserPermission.EDIT],
          fields: [
            {
              field: UserPermissionWidgetField.REDIRECT_BUTTON,
              permissions: [UserPermission.EDIT],
            },
          ],
        },
      ],
      accessPlatforms: [
        Platform.bazaar,
        Platform.cosmo,
        Platform.esquire,
        Platform.goodhouse,
        Platform.grazia,
        Platform.mhealth,
        Platform.popmech,
        Platform.robb,
        Platform.girlspower,
      ],
    },
    {
      title: 'Товарная карточка',
      slug: 'imageset',
      icon: 'mdi-tag-outline',
      svg: false,
      raw: {
        widget_type: 'goods',
      },
      accessPlatforms: [
        Platform.bazaar,
        Platform.esquire,
        Platform.grazia,
        Platform.mhealth,
        Platform.popmech,
        Platform.robb,
        Platform.girlspower,
      ].filter((platfrom) => !ENABLED_GOODS_WIDGET.includes(platfrom)),
    },
    {
      title: 'Товарная карточка',
      slug: 'goods',
      icon: 'mdi-tag-outline',
      svg: false,
      accessPlatforms: ENABLED_GOODS_WIDGET,
    },
    {
      title: 'Таблицы',
      slug: 'table',
      icon: 'mdi-table',
      svg: false,
    },
    {
      title: '1 слот',
      slug: 'dummy',
      icon: 'mdi-numeric-1-box-outline',
      svg: false,
      includeArticleTypes: [ArticleTypeCode.PHOTO],
    },
    {
      title: '2 слота',
      slug: 'dummy',
      icon: 'mdi-numeric-2-box-outline',
      svg: false,
      count: 2,
      includeArticleTypes: [ArticleTypeCode.PHOTO],
    },
    {
      title: '3 слота',
      slug: 'dummy',
      icon: 'mdi-numeric-3-box-outline',
      svg: false,
      count: 3,
      includeArticleTypes: [ArticleTypeCode.PHOTO],
    },
    {
      title: '4 слота',
      slug: 'dummy',
      icon: 'mdi-numeric-4-box-outline',
      svg: false,
      count: 4,
      includeArticleTypes: [ArticleTypeCode.PHOTO],
    },

    {
      title: 'Пост из соцсети',
      slug: 'imageset',
      icon: 'mdi-share-variant-outline',
      svg: false,
      raw: {
        source_type: ImageWidgetSourceType.SOCIAL_IMAGE_POST,
      },
    },
    {
      title: 'Календарь',
      slug: 'calendar',
      icon: 'mdi-calendar-month-outline',
      svg: false,
      accessPlatforms: [Platform.goodhouse],
      hiddenMobile: true,
    },
  ]

  return widgets
}

export const supportsGroupedBlocks = ['photos', 'video', 'text-block', 'dummy']
